module.exports = __webpack_public_path__ + "assets/img/fr-20899463.png";